/* TrioMi CardStudio – Landingpages: Einblenden beim Scrollen, 3D-Neigung der Karten, „Mehr lesen“ */
(function () {
  'use strict';
  function init(root) {
    // Einblenden
    var els = root.querySelectorAll('.tcs-r:not(.in)');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      els.forEach(function (el) { io.observe(el); });
    } else els.forEach(function (el) { el.classList.add('in'); });

    // 3D-Neigung + wandernder Holo-Glanz (nur mit Maus)
    if (window.matchMedia('(hover: hover)').matches) {
      root.querySelectorAll('.tcs-tilt').forEach(function (t) {
        var card = t.querySelector('.tcs-card');
        if (!card || t.dataset.tilt) return;
        t.dataset.tilt = '1';
        t.addEventListener('pointermove', function (e) {
          var r = t.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
          card.style.transform = 'rotateY(' + ((x - .5) * 18).toFixed(1) + 'deg) rotateX(' + ((.5 - y) * 18).toFixed(1) + 'deg) scale(1.03)';
          card.style.setProperty('--hx', (x * 100).toFixed(0) + '%'); card.style.setProperty('--hy', (y * 100).toFixed(0) + '%');
        });
        t.addEventListener('pointerleave', function () { card.style.transform = ''; });
      });
    }

    // SEO-Text „Mehr lesen“
    root.querySelectorAll('[data-tcs-more]').forEach(function (b) {
      if (b.dataset.bound) return; b.dataset.bound = '1';
      b.addEventListener('click', function () {
        var box = document.getElementById(b.dataset.tcsMore);
        var open = box.classList.toggle('open');
        b.textContent = open ? b.dataset.less : b.dataset.more;
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  // Theme-Editor: neu geladene Sections
  document.addEventListener('shopify:section:load', function (e) { init(e.target); e.target.querySelectorAll('.tcs-r').forEach(function (el) { el.classList.add('in'); }); });
})();
